import { useState } from "react";
import { useHubspotForm } from "@aaronhayes/react-use-hubspot-form";
import { ReactComponent as CloseIcon } from "./Close.svg";
import { SET_MORE_TOOLS_FORM_IS_SUBMITTED } from './consts';

import "./index.css";

// Pseudo-jQuery for Hubspot callbacks to avoid loading jQuery script
// jQuery is needed for hubspot forms onFormSubmit method, but only as query tool, so we can improve performance by not loading jQuery
(function () {
  window.jQuery =
    window.jQuery ||
    function (nodeOrSelector) {
      if (typeof nodeOrSelector === "string") {
        return document.querySelector(nodeOrSelector);
      }
      return nodeOrSelector;
    };
})();

// TODO this has to be refactored, it's a prototype
export const MoreToolsModal = ({ isOpen, onClose }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  useHubspotForm({
    region: "na1",
    portalId: "9021803",
    formId: "b320dbea-707a-4345-8bcd-b9521d6e048c",
    sfdcCampaignId: "7014v000002S16OAAS",
    target: "#hubspotForm",
    onFormReady() {
      // this hack is needed to update value properly because this method is called is updating the value after running it, we need to pop it out from callstack and run afterwards
      setTimeout(() => {
        document.querySelector('input[type="submit"].hs-button').value =
          "Get More Tools";
      }, 20);
    },
    onFormSubmit() {
      const conversionPageInput = document.querySelector(
        'input[name="conversion_page"]'
      );

      if (!conversionPageInput.value) {
        conversionPageInput.value = "oysterlabs_benefits_advisor";
        conversionPageInput.dispatchEvent(
          new Event("input", { bubbles: true })
        );
      }
    },
    onFormSubmitted() {
      setIsSubmitted(true);
      window.parent?.postMessage?.(
        {
          name: SET_MORE_TOOLS_FORM_IS_SUBMITTED,
        },
        '*'
      );
    },
  });

  return (
    <div
      onClick={() => {
        if (isSubmitted) {
          // not possible case, but if we will allow to open form for the second time it will prevent from having issues
          setIsSubmitted(false);
          onClose();
        }
      }}
      className="modal-overlay"
      style={{
        display: isOpen ? "flex" : "none",
      }}
    >
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {isSubmitted && (
          <CloseIcon
            width={50}
            height={50}
            className="close-icon"
            onClick={onClose}
          />
        )}
        {!isSubmitted && (
          <div className="modal-heading">
            Get unlimited access to the Benefits Advisor and Oyster's full suite of free global employment tools
          </div>
        )}
        <div id="hubspotForm" />
      </div>
    </div>
  );
};
